<template>
  <v-btn
    :[iconPlaceHolder]="computedIcon"
    :color="computedColor"
    :[variantPlaceholder]="computedVariant">
    DELETE
  </v-btn>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps(['icon', 'color', 'variant']);

const iconPlaceHolder = computed(() => {
  return props.icon === '' ? null : 'prepend-icon';
});

const computedIcon = computed(() => {
  return !props.icon ? 'mdi-trash-can-outline' : props.icon;
});

const computedColor = computed(() => {
  return !props.color ? 'error' : props.color;
});

const computedVariant = computed(() => {
  return !props.variant ? null : props.variant;
});

const variantPlaceholder = computed(() => {
  return !props.variant ? null : 'variant';
});
</script>
